import { render, staticRenderFns } from "./documentoTransferencia.vue?vue&type=template&id=3c8a76c4&scoped=true"
import script from "./documentoTransferencia.vue?vue&type=script&lang=js"
export * from "./documentoTransferencia.vue?vue&type=script&lang=js"
import style0 from "./documentoTransferencia.vue?vue&type=style&index=0&id=3c8a76c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8a76c4",
  null
  
)

export default component.exports